import React, { Component } from 'react';
import Bio from './bio'
import { PureComponent } from 'react';

class Advertisement extends PureComponent {

    constructor(props) {
        super(props);
        // this.autoComplete.bind(this)

    }





    render() {
        let { config } = this.props;
        return (
            <div className="si-sponser-ad">
                <img src={ config.playerImgBase + "/sponser-ad.png?v=" + config.WebConfig.imgVersion } />
            </div>)
    }
}

export default Advertisement;

